import { Routes } from '@angular/router';
import { Contact } from './contact.component';
import { ContactSuccess } from './contact-success/contact-success.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: Contact,
    title: 'Contact - Hill Tech Works',
    data: {
      showAction: false,
      description: 'Start your project with Hill Tech Works. Tell us what you\'re building and we\'ll help you make it happen.',
      breadcrumbs: [
        { name: 'Home', item: 'https://hilltechworks.com' },
        { name: 'Contact', item: 'https://hilltechworks.com/contact' },
      ],
    }
  },
  {
    path: 'success',
    component: ContactSuccess,
    title: 'Thank You - Hill Tech Works',
    data: {
      showAction: false,
      noindex: true,
      description: 'Thanks for reaching out to Hill Tech Works. We\'ll be in touch soon.',
      breadcrumbs: [
        { name: 'Home', item: 'https://hilltechworks.com' },
        { name: 'Contact', item: 'https://hilltechworks.com/contact' },
        { name: 'Thank You', item: 'https://hilltechworks.com/contact/success' },
      ],
    }
  },
];
